import { render } from "./PeopleGroupsSection.vue?vue&type=template&id=f708abe2"
import script from "./PeopleGroupsSection.vue?vue&type=script&lang=js"
export * from "./PeopleGroupsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__